module.exports = __webpack_public_path__ + "img/citibank.a6632ee8.svg";